import { JourneyItem } from 'pages/our-story/components/JourneyItem'
import TelephoneBox from '../../../assets/OurStoryImages/TelephoneBox.svg'

export const Section2 = () => {
  return (
    <div className='flex flex-col sm:flex-row py-20 sm:gap-10 3xl:py-52 xl:gap-20'>
      <img src={TelephoneBox} className='w-[295px] h-auto 3xl:w-[445px] 3xl:h-[956px]' />
      <div className='flex flex-col justify-between pt-20 sm:pt-0'>
        <div className='flex flex-col space-y-1'>
          <JourneyItem
            title='Founded in the UK'
            emoji='🇬🇧'
            tagline='to make an impact'
          />
          <JourneyItem
            title='Designed by a Brazilian'
            emoji='🇧🇷'
            tagline='for every type of user'
          />
          <JourneyItem
            title='Built around the world'
            emoji='🌍'
            tagline='for global application'
          />
        </div>
        <p className='pt-20 text-lg font-bold text-[#101828] leading-6 tracking-[0.4px] lg:text-xl 3xl:text-[40px] 3xl:leading-normal 3xl:pt-0'>
          Our journey began with a British founder, brought to life with a
          Brazilian’s design, and developed by a diverse team working from
          around the world.
          <br /> <br />
          Today, we work from offices in London, Delaware, and São Paulo.
        </p>
      </div>
    </div>
  )
}
